import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import styled, { css } from 'styled-components';
import { colors } from '../../constants/colors';
import { fontFamily, fontSize } from '../../constants/text';

const StyledDialogContent = styled(DialogContent)`
  font-family: ${fontFamily.book};
  color: ${colors.blueMonday};
`;

const StyledDialogTitle = styled(DialogTitle)`
  h2 {
    font-family: ${fontFamily.medium};
    color: ${colors.squid};
    font-size: ${fontSize.medium};
  }
`;

const StyledActions = styled(DialogActions)`
  justify-content: center;
`;

class SolvDialog extends PureComponent {
  static propTypes = {
    title: PropTypes.string,
    actions: PropTypes.node,
    width: PropTypes.number,
    children: PropTypes.node,
  };

  static defaultProps = {
    width: 400,
  };

  getPaperProps = () => ({
    style: {
      width: '100%',
      maxWidth: `${this.props.width}px`,
    },
  });

  render = () => (
    <Dialog {...this.props} PaperProps={this.getPaperProps()}>
      {this.props.title && <StyledDialogTitle>{this.props.title}</StyledDialogTitle>}
      <StyledDialogContent>{this.props.children}</StyledDialogContent>
      {this.props.actions && <StyledActions>{this.props.actions}</StyledActions>}
    </Dialog>
  );
}

export default SolvDialog;
